import React, { useState, useEffect } from 'react'
import FormikControl from '../../hoc/formikComponents/FormikControl'
import { useMutation, useQuery } from 'react-query'
import ToastInstance from '../../hoc/NotificationSettings/ToastInstance'
import Fetcher from '../../hoc/FetcherSetting/FetcherSetting'
import { useParams } from 'react-router'
import { useHistory } from "react-router-dom";
import moment from 'moment';
import * as Yup from 'yup'
import { Formik, Form, Field, FieldArray } from 'formik';
import * as AiIcons from 'react-icons/ai';
import swal from '@sweetalert/with-react';

function Observation() {
    const history = useHistory();
    const { orgcode } = useParams()
    const [leadauditorList, setLeadauditorList] = useState([{
        label: "",
        value: ""
    }])
    const [tempOrgCode, settempOrgCode] = useState(0)

    const [initialValues, setInitialValues] = useState({
        _id: "",
        orgCode: 0,
        address: "",
        siteofaddress: 'NA',
        effectiveNoEmpToBeAudited: "",
        mobile: "",
        email: "",
        scope: "",
        nabcbcodeName: "",
        contactPersonName: "",
        dateofaudit: "",
        auditteam: "",
        purpose: "",
        businesssector: "",
        teamleaderName: "",
        accompanyingteam: "",
        purspose: "",
        significantchanges: "",
        technicalexpertName: "",
        datestage2observation: "",
        placeofaudit: "",
        anydeviationinauditplan: "",
        briefaboutorg: "",
        anysignificantissue: "",
        anyunresolved: "",
        criteriaofaudit: "",
        objectiveofaudit: "",
        verificationofeffectiveness: "",
        externalissues: "",
        internalissues: "",
        needsandexpectations: "",
        riskandopportunity: "",

        processAuditReportDetails: [{
            nameofprocess: "",
            processowner: "",
            details: "",
            reference: "",
            comments: "",
            clauseWiseObservation: [{ clauseNo: "", Observation: "" }],
            clausesList: [{ label: "Select", value: "-" }]


        }],
        
        obervations: "",
        opportunitiesforimprovment: "",
        positivefindingsSurveillance: "",
        gpPvtHealthSubCenterOptions: "Yes",
        typeofaudit: "Initial Audit",
        Auditor: "",
        designanddevelopment: "",
        fileno: "",
        reportno: "",
        anychangessincelastaudit: "",
        verificationofcertification: "",
        improvementmade: "",
        purpose: "",
        surveillanceType: "",
        surveillanceTypeName: "",
        ncstatementifany:"",
        // recommendationType:""
        reportsubdate:"",
        nameofauditor:"",
        clientname:"",
        clientdesignation:"",
        survellianceOneremark:"",
        survellianceTworemark:"",
        survellianceThreeremark:"",
        survellianceFourremark:"",
        survellianceFiveremark:"",
        survellianceSixremark:"",
        survellianceSevenremark:"",
        auditorcommentnoncon:"",
        techreviewercomment:"",
        cdcreviewremark:""
    })

    const recommendationType = [
        { key: 'Select', value: '-' },
        { key: 'Certification status Continued for next year', value: 'Certification status Continued for next year' },
        { key: 'Follow up Audit - on site', value: 'Follow up Audit - on site' },
        { key: 'Follow up audit - On site', value: 'Follow up audit - On site' },
        { key: 'Certificate continued after successful Follow up audit', value: 'Certificate continued after successful Follow up audit' },
        { key: 'Certificate status canceled due to non fulfillment of requirements', value: 'Certificate status canceled due to non fulfillment of requirements' }

    ]

    const gpPvtHealthSubCenterOptions = [
        { key: 'Yes', value: 'Yes' },
        { key: 'No', value: 'No' }
    ]
    const types = [
        { label: "Select", value: "-" },
        { label: "Suveillance 1", value: "Sureillance1" },
        { label: "Surveillance 2", value: "Surveillance2" }

    ]
    const typeofaudit = [
        { key: 'Initial Audit ', value: 'Initial Audit' },
        { key: 'Special Audit', value: 'Special Audit' }
    ]

    const { data: processList, isLoading: processListLoading } = useQuery(
        'listprocess',
        () => Fetcher('get', '/api/clauses/get/listclauseswithkeylabel', {}))

    const { data: OrgList, isLoading: companyListLoading } = useQuery(
        'listAuditPlan',
        () => Fetcher('get', '/api/survillance/get/companylistbyroleforsurvillanceObservationandMatrix/' + localStorage.getItem("userCode"), {}))
        
    const mutationLeadAudiorDetails = useMutation((params) => Fetcher('get', '/api/profile/get/keyvalueforleadauditorsCommonNacecode/' + params, {}), {
        onSuccess(data) {
          
            if (data.data.errorCode === 0) {
                setLeadauditorList(data.data.response)
            } else {
                var msg = 'Subject - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Subject' + error)
        }
    })

    const mutationgetCompanyDetailsSurveillanceOne = useMutation((params) => Fetcher('get', '/api/survillance/get/surveillanceOneDetails/' + params, {}), {
        onSuccess(data) {
          console.log("data 154",data.data.response)
            if (data.data.errorCode === 0) {
                var tempInitialValues = data.data.response;
                tempInitialValues.orgCode = data.data.response.orgCode
                tempInitialValues.address = data.data.response.address || "";
                tempInitialValues.effectiveNoEmpToBeAudited = data.data.response.effectiveNoEmpToBeAudited || "";
                tempInitialValues.email = data.data.response.email || "";
                tempInitialValues.contactPersonName = data.data.response.contactPersonName || "";
                tempInitialValues.dateofaudit = Date.parse(data.data.response.dateofaudit) || null;

                tempInitialValues.datestage2observation = Date.parse(data.data.response.datestage2observation) || null;
                tempInitialValues.auditteam = data.data.response.auditteam || "";
                tempInitialValues.mobile = data.data.response.mobile || "";
                tempInitialValues.placeofaudit = data.data.response.placeofaudit || "";
                tempInitialValues.significantchanges = data.data.response.significantchanges || "";
                tempInitialValues.positivefindingsSurveillance = data.data.response.positivefindingsSurveillance;
                tempInitialValues.nabcbcodeName = data.data.response.nabcbcodeName || "";
                tempInitialValues.typeofaudit = data.data.response.typeofaudit || "Initial Audit";
                tempInitialValues.siteofaddress = data.data.response.siteofaddress || "NA";
                tempInitialValues.purpose = data.data.response.purpose || "";
                tempInitialValues.externalissues = data.data.response.externalissues || "";
                tempInitialValues.processAuditReportDetails = data.data.response.processAuditReportDetails.length > 0 ? data.data.response.processAuditReportDetails : [{
                    nameofprocess: "",
                    nameofprocessid:"",
                    processowner: "",
                    details: "",
                    reference: "",
                    comments: "",
                    clausesList: [],
                    clauseWiseObservation: [{ clauseNo: "", Observation: "" }],
                    
                }];
                tempInitialValues.surveillanceType = data.data.response.surveillanceType || "Sureillance1";
                tempInitialValues.surveillanceTypeName = data.data.response.surveillanceTypeName || "Sureillance 1";
                tempInitialValues.reportsubdate = Date.parse(data.data.response.reportsubdate) || null;
                if(data.data.response.processAuditReportDetails.length > 0)
                {
                    console.log("data.data.response.processAuditReportDetails.length",data.data.response.processAuditReportDetails.length)
                    for(let j = 0 ; j < tempInitialValues.processAuditReportDetails.length ; j++){
                        console.log("processList.data.response",processList.data.response)
                        console.log("processList.data.response",processList.data.response)
                        console.log("tempInitialValues.processAuditReportDetails[j]",tempInitialValues.processAuditReportDetails[j])
                        var clauseListdata = processList.data.response.find(e=> e.label === tempInitialValues.processAuditReportDetails[j].nameofprocess)
                    
                        console.log("clauseListdata 165",clauseListdata)
                        tempInitialValues.processAuditReportDetails[j].clausesList = clauseListdata.clausesList
                        
                        tempInitialValues.processAuditReportDetails[j].clausesList = clauseListdata.clausesList
                       
                    }
                }
                setInitialValues(tempInitialValues)
            } else {
                var msg = 'Company - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Get Company Details' + error)
        }
    })


    const mutationgetCompanyDetailSurveillanceTwo = useMutation((params) => Fetcher('get', '/api/survillanceTwo/get/surveillanceTwoDetails/' + params, {}), {
        onSuccess(data) {
            console.log("data 220",data.data.response)
            if (data.data.errorCode === 0) {
                var tempInitialValues = data.data.response;
                tempInitialValues.orgCode = data.data.response.orgCode
                tempInitialValues.address = data.data.response.address || "";
                tempInitialValues.effectiveNoEmpToBeAudited = data.data.response.effectiveNoEmpToBeAudited || "";
                tempInitialValues.email = data.data.response.email || "";
                tempInitialValues.contactPersonName = data.data.response.contactPersonName || "";
                tempInitialValues.dateofaudit = Date.parse(data.data.response.dateofaudit) || null;
                tempInitialValues.surveillanceType = data.data.response.surveillanceType || "Sureillance2";
                tempInitialValues.surveillanceTypeName = data.data.response.surveillanceTypeName || "Sureillance 2";
                tempInitialValues.datestage2observation = Date.parse(data.data.response.datestage2observation) || null;
                tempInitialValues.auditteam = data.data.response.auditteam || "";
                tempInitialValues.mobile = data.data.response.mobile || "";
                tempInitialValues.placeofaudit = data.data.response.placeofaudit || "";
                tempInitialValues.significantchanges = data.data.response.significantchanges || "";
                tempInitialValues.positivefindingsSurveillance = data.data.response.positivefindingsSurveillance || "";
                tempInitialValues.nabcbcodeName = data.data.response.nabcbcodeName || "";
                tempInitialValues.typeofaudit = data.data.response.typeofaudit || "Initial Audit";
                tempInitialValues.siteofaddress = data.data.response.siteofaddress || "NA";
                tempInitialValues.purpose = data.data.response.purpose || "";
                tempInitialValues.externalissues = data.data.response.externalissues || ""
                tempInitialValues.reportsubdate = Date.parse(data.data.response.reportsubdate) || null;
                tempInitialValues.processAuditReportDetails = data.data.response.processAuditReportDetails.length > 0 ? data.data.response.processAuditReportDetails : [{
                    nameofprocess: "",
                    nameofprocessid:"",
                    processowner: "",
                    details: "",
                    reference: "",
                    comments: "",
                    clausesList: [],
                    clauseWiseObservation: [{ clauseNo: "", Observation: "" }],
                }]
                if(data.data.response.processAuditReportDetails.length > 0)
                {
                    for(let j = 0 ; j < tempInitialValues.processAuditReportDetails.length ; j++){
                       
                        var clauseListdata = processList.data.response.find(e=> e.label === tempInitialValues.processAuditReportDetails[j].nameofprocess)
                      
                        tempInitialValues.processAuditReportDetails[j].clausesList = clauseListdata.clausesList
                    }
                }
    
                setInitialValues(tempInitialValues)
            } else {
                var msg = 'Surveillance Onservation - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Get Company Details' + error)
        }
    })

    const onSubmit = (values, { setSubmitting, resetForm }) => {
             

        if(values.surveillanceType ===  "Sureillance1" )
        {
           mutation.mutate(values)
        }
        else
        {
           mutationSurveillancetwo.mutate(values)
        }
    }


    const mutation = useMutation((params) => Fetcher('patch', '/api/survillance/patch/surveillanceSecondetails', params), {
        onSuccess(data) {
           
            if (data.data.errorCode === 0) {
                ToastInstance('Success', ' Surveillance Observation Data Filled')
                window.location.href = "/" + localStorage.getItem("role") + "/view/surveillanceobservation/" + data.data.response.orgCode
            } else {
                var msg = 'Subject - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Subject' + error)
        }
    })

    const  mutationSurveillancetwo = useMutation((params) => Fetcher('patch', '/api/survillanceTwo/patch/surveillancetwoobservationdetails', params), {
        onSuccess(data) {
           
            if (data.data.errorCode === 0) {
                ToastInstance('Success', ' Surveillance Two Observation  Data Filled')
                window.location.href = "/"+localStorage.getItem("role")+"/view/surveillancetwoobservation/" + data.data.response.orgCode
            } else {
                var msg = 'Subject - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Subject' + error)
        }
    })
    const { data: Rfqdata, isLoading } = useQuery(
        'listrfq',
        () => { if (orgcode) return Fetcher('get', '/api/survillance/get/surveillancedata/' + orgcode, {}) })

    useEffect(() => {
        if (Rfqdata && initialValues.orgCode === 0) {
            var tempData = Rfqdata.data.response
            tempData.dateofaudit = Date.parse(tempData.dateofaudit);
            tempData.datesur = Date.parse(tempData.datesur);
            tempData.duedate = Date.parse(tempData.duedate);
            tempData.datestage2observation = Date.parse(tempData.datestage2observation)
            tempData.reportsubdate = Date.parse(tempData.reportsubdate);
            setInitialValues(tempData)
            // if (tempData.nabcbcode && tempData.nabcbcode !== "") {
            //     mutationLeadAudiorDetails.mutate(tempData.nabcbcode)
            // }


        }
    }, [orgcode && !isLoading && initialValues.orgCode === 0])
    const validationSchema= Yup.object({
        fileno      : Yup.string().required('Required'),
        reportno    : Yup.string().required('Required'),
        anychangessincelastaudit : Yup.string().required('Required'),
        verificationofcertification : Yup.string().required('Required'),
    


    })
    if (companyListLoading || processListLoading) return <h1>Loading</h1>

    return (
        <div>
            <Formik
                enableReinitialize={true}
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
            >
                {
                    formik => <Form>
                        <div className="content-wrapper">
                            <section className="content">
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div className="card-body">
                                                <div className="row">
                                                    <div className="col-sm-12">
                                                        <form>
                                                            <div className="formOuterDiv">
                                                                {/* <div className="form1RowDiv">
                                                                    <FormikControl control='selectNACECode' name='orgCode' options={OrgList.data.response} onChange={e => { mutationgetCompanyDetailsSurveillanceOne.mutate(e.value); }} label='Organization' />
                                                                </div> */}
                                                                 <div className="form1RowDiv">
                                                                <FormikControl control='selectNACECode' options={OrgList.data.response} name='orgCode' type="text" label='Client Name' onChange={(e) => {
                                                                    formik.setFieldValue(`orgCode`, e.value)
                                                                    formik.setFieldValue(`orgName`, e.label)
                                                                    settempOrgCode(e.value)

                                                                }} />

                                                            </div>
                                                            <div className="form1RowDiv">
                                                            
                                                            <FormikControl control='selectNACECode' options={types}  name='surveillanceType' 
                                                               
                                                            onChange={e => {
                                                                
                                                                formik.setFieldValue(`surveillanceType`, e.value)
                                                                formik.setFieldValue(`surveillanceTypeName`,e.label)
                                                            e.value === 'Sureillance1' ? 
                                                             mutationgetCompanyDetailsSurveillanceOne.mutate(tempOrgCode)
                                                            :mutationgetCompanyDetailSurveillanceTwo.mutate(tempOrgCode)
                                                        
                                                            
                                                            }} type="text" label='Surveillance Type' 
                                                           
                                                            /> 

                                                        </div> 
                                                                <div className="form2RowDiv">
                                                                    <FormikControl control='input' type="text" name='fileno' label='File No' />
                                                                    <FormikControl control='input' type="text" name='reportno' label='Report No' />

                                                                </div>

                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='input' type="text" name='address' label='Address' className="form-control" disabled={true} />
                                                                </div>

                                                                <div className="form2RowDiv">
                                                                    <FormikControl control='input' type="text" name='siteofaddress' label='Site Address (If any)' disabled={true} />
                                                                    <FormikControl control='input' type="text" name='effectiveNoEmpToBeAudited' label='No. of Employees' disabled={true} />

                                                                </div>
                                                                <div className="form2RowDiv">
                                                                <FormikControl control='input' type="text" name='contactPersonName' label='Contact Person' disabled={true} />
                                                                    <FormikControl control='input' type="text" name='email' label='Email id' disabled={true} />
                                                                

                                                                </div>
                                                                <div className="form2RowDiv">
                                                                    <FormikControl control='input' type="text" name='mobile' label='Mobile/Fax' disabled={true} />
                                                                  

                                                                </div>
                                                                <div className="form1RowDiv">
                                                                  <FormikControl control='input' type="text" name='nabcbcodeName' label='ANZSIC Code / NACE CODE' disabled={true} />
                                                                </div>
                                                              
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='textarea' type="text" name='scope'  label='Scope' className="form-control" />
                                                                </div>
                                                                <div className="row mt-3" style={{ marginLeft: "0.5%" }}>
                                                                    <div className="col-sm-7 text-dark">
                                                                        <label>Non applicable requirements as determined by organisation: </label>
                                                                    </div>
                                                                    <div className="col-sm-5">
                                                                        <p>All Clauses are applicable</p>
                                                                    </div>

                                                                    <div className="row mt-2">
                                                                        <div className="row">
                                                                            <label htmlFor="staticEmail" className="col-sm-6">Justification for Non applicability checked and accepted?</label>
                                                                            <div className="col-sm-6">
                                                                                <FormikControl control='radio' name='gpPvtHealthSubCenterOptions' options={gpPvtHealthSubCenterOptions} />

                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row mt-3">
                                                                        <div className="row">
                                                                            <label htmlFor="staticEmail" className="col-sm-6">Type Of Audit</label>
                                                                            <div className="col-sm-6">
                                                                                <FormikControl control='radio' name='typeofaudit' options={typeofaudit} />
                                                                            </div>

                                                                        </div>
                                                                        <p className="mt-4"><b>Note: </b><i>Combined/Joint/integrated audit(If Applicable) </i></p>
                                                                    </div>
                                                                </div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='input' type="text" name='significantchanges' label='Significant Changes(if any),Since last audit that affects QMS'  />
                                                                </div>

                                                                <div className="hrstyle">
                                                                    <h5>Audit Team</h5>
                                                                </div>

                                                                <div className="form2RowDiv">
                                                                    {/* <FormikControl control="selectNACECode" name="teamleader" label="Team Leader/ Lead Auditor" options={leadauditorList}
                                                                onChange={(e) => {
                                                                    formik.setFieldValue(`teamleader`, e.value)
                                                                    formik.setFieldValue(`teamleaderName`, e.label)
                                                                }}
                                                                disabled={true} /> */}

                                                                    <FormikControl control='input' type='text' label='Team Leader/ Lead Auditor' name='teamleaderName' disabled={true} />

                                                                    <FormikControl control='input' type='text' label='Technical expert' name='technicalExpertName' disabled={true} />

                                                                </div>
                                                                <div className="form2RowDiv">
                                                                    <FormikControl control='input' type='text' label='Auditor One' name='auditorOneName' disabled={true} />
                                                                    <FormikControl control='input' type='text' label='Auditor Two ' name='auditorTwoName' disabled={true} />

                                                                </div>
                                                                <div className="form2RowDiv">
                                                                    <FormikControl control='date' dateFormat="dd-MM-yyyy" name='datestage2observation' className="form-control" label='Audit Date' disabled={true} />
                                                                   

                                                                </div>
                                                                <div className="form2RowDiv">
                                                                   
                                                                    <FormikControl control='textarea' type="text" name='purpose' label='Objective of Audit'  />

                                                                </div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='textarea' type="text" name='anychangessincelastaudit' label='Any Changes Since Last Audit (Name, Address, Scope, Site etc.)' />
                                                                </div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='textarea' type="text" name='verificationofcertification' label='Verification of use of Certification Mark and Logo' />
                                                                </div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='textarea' type="text" name='improvementmade' label='Improvement Made in Last One Year' />
                                                                </div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='textarea' type="text" name='anydeviationinauditplan' label='Any Deviation in the Audit Plan and Reason(if any)'  />
                                                                </div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='textarea' type="text" name='briefaboutorg' label='Brief about the organization'  />
                                                                </div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='input' type="text" name='anysignificantissue' label='Any Significant issue impacting on the Audit Programme'  />
                                                                </div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='input' type="text" name='anyunresolved' label='Any unresolved issues(if identified)'  />
                                                                </div>

                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='textarea' type="text" name='criteriaofaudit' label='Criteria of Audit(Disclaimer Statement)'  />
                                                                </div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='textarea' type="text" name='objectiveofaudit' label='Objective of Audit'  />
                                                                </div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='textarea' type="text" name='verificationofeffectiveness' label='Verification of effectiveness of NC closure of Previous Audit(If any)'  />
                                                                </div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='textarea' type="text" name='externalissues' label='External Issues'  />
                                                                </div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='textarea' type="text" name='internalissues' label='Internal Issues'  />
                                                                </div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='textarea' type="text" name='needsandexpectations' label='Needs and Expectations of interested parties'  />
                                                                </div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='textarea' type="text" name='riskandopportunity' label='Risk & Opportunity & Change Control'  />
                                                                </div>


                                                                <div className="fieldarray mt-3">

                                                                    <FieldArray name='processAuditReportDetails'>

                                                                        {fieldArrayProps => {
                                                                            const { push, remove, form } = fieldArrayProps
                                                                            const { values } = form
                                                                            const { processAuditReportDetails } = values
                                                                            return (
                                                                                <div>
                                                                                    {processAuditReportDetails.map((processDetail, index) => (
                                                                                        <div key={index}>
                                                                                            <div className="form2RowDiv">
                                                                                                <div className="formSingleElement">
                                                                                                    <FormikControl control="selectNACECode" name={`processAuditReportDetails[${index}].nameofprocessid`} label='Name of the Process' options={processList.data.response}
                                                                                                        onChange={(e) => {

                                                                                                            var fillteredprocess = processAuditReportDetails.find(x => x.nameofprocessid === e.value)

                                                                                                            if (fillteredprocess) {
                                                                                                                swal({
                                                                                                                    title: "Process is Already selected",
                                                                                                                    icon: "warning",
                                                                                                                    dangerMode: true,
                                                                                                                })
                                                                                                            } else {
                                                                                                                formik.setFieldValue(`processAuditReportDetails[${index}].nameofprocess`, e.label)
                                                                                                                formik.setFieldValue(`processAuditReportDetails[${index}].nameofprocessid`, e.value)

                                                                                                                formik.setFieldValue(`processAuditReportDetails[${index}].reference`, e.listClauses)

                                                                                                                formik.setFieldValue(`processAuditReportDetails[${index}].clausesList`, e.clausesList)


                                                                                                            }

                                                                                                        }

                                                                                                        } />

                                                                                                </div>
                                                                                                <div className="formSingleElement">
                                                                                                    <label className="formSingleElementLabel">Process Owner</label>
                                                                                                    <Field className="form-control" name={`processAuditReportDetails[${index}].processowner`} />
                                                                                                </div>
                                                                                            </div>


                                                                                            <div className="form1RowDiv ">
                                                                                                <div className="formSingleElement">
                                                                                                    <label className="formSingleElementLabel">References</label>
                                                                                                    <Field className="form-control" name={`processAuditReportDetails[${index}].reference`} />
                                                                                                </div>
                                                                                            </div>

                                                                                            <div className="row mt-5" style={{ margin: "1%" }}>

                                                                                                <div className="col-sm-11">
                                                                                                    <label htmlFor="staticEmail" className="col-sm-5 mt-1 mb-1">Details</label>
                                                                                                    <FormikControl control='ckEditor' name={`processAuditReportDetails[${index}].details`} className="form-control" data={initialValues.processAuditReportDetails.details} />
                                                                                                </div>
                                                                                            </div>
                                                                                            <div className="row mt-3" style={{ margin: "1%" }}>
                                                                                                <label className="formSingleElementLabel">Auditor comments on</label>
                                                                                                <Field as='textarea' className="form-control" name={`processAuditReportDetails[${index}].comments`} />
                                                                                            </div>

                                                                                            <div className="fieldarray mt-3">

                                                                                                <FieldArray name={`processAuditReportDetails[${index}].clauseWiseObservation`}>

                                                                                                    {fieldArrayProps => {
                                                                                                        const { push, remove, form } = fieldArrayProps
                                                                                                        const { values } = form
                                                                                                        const { clauseWiseObservation } = values
                                                                                                        return (
                                                                                                            <div>
                                                                                                                {processAuditReportDetails[index].clauseWiseObservation.map((clauseDetail, i) => (
                                                                                                                    <div key={index}>
                                                                                                                        <div className="form2RowDiv">
                                                                                                                            <div className="formSingleElement">
                                                                                                                                {<FormikControl control="selectNACECode" name={`processAuditReportDetails[${index}].clauseWiseObservation[${i}].clauseNo`} label='Clause' options={processAuditReportDetails[index].clausesList}
                                                                                                                                    onChange={(e) => {

                                                                                                                                        var fillteredprocess = processAuditReportDetails[index].clauseWiseObservation.find(x => x.clauseNo === e.value)

                                                                                                                                        if (fillteredprocess) {
                                                                                                                                            swal({
                                                                                                                                                title: "Clause is Already selected",
                                                                                                                                                icon: "warning",
                                                                                                                                                dangerMode: true,
                                                                                                                                            })
                                                                                                                                        } else {
                                                                                                                                            var fillteredprocess = processAuditReportDetails[index].clauseWiseObservation.find(x => x.clauseNo === e.value)

                                                                                                                                            if (fillteredprocess) {
                                                                                                                                                swal({
                                                                                                                                                    title: "Clause is Already selected",
                                                                                                                                                    icon: "warning",
                                                                                                                                                    dangerMode: true,
                                                                                                                                                })
                                                                                                                                            } else {

                                                                                                                                                formik.setFieldValue(`processAuditReportDetails[${index}].clauseWiseObservation[${i}].clauseNo`, e.value)
                                                                                                          

                                                                                                                                            }
                                                                                                                                        }

                                                                                                                                    }

                                                                                                                                    }
                                                                                                                                />}

                                                                                                                            </div>
                                                                                                                            
                                                                                                                         </div>
                                                                                                                         
                                                                                                                       
                                                                                                                        <div className="row mt-3" style={{ margin: "1%" }}>
                                                                                                                            <label className="formSingleElementLabel">Observation</label>
                                                                                                                            <Field as='textarea' className="form-control" name={`processAuditReportDetails[${index}].clauseWiseObservation[${i}].Observation`} />
                                                                                                                        </div>

                                                                                                                        {i > 0 && (
                                                                                                                            <div className="col-sm-4">
                                                                                                                                <span style={{ "marginLeft": "290%", "cursor": "pointer" }} onClick={() => remove(i)}><AiIcons.AiOutlineDelete style={{ widh: "30px", fill: "red" }} /></span>
                                                                                                                            </div>
                                                                                                                        )}

                                                                                                                        <hr />

                                                                                                                        </div>

                                                                                                                ))}


                                                                                                                <div className="row mt-3">
                                                                                                                    <div className="col-lg-11"></div>
                                                                                                                    <div className="col-lg-1 mb-3" >
                                                                                                                        <button type='button' className="btn btn-primary" onClick={() => push({
                                                                                                                            clauseNo: "",
                                                                                                                            Observation: "",

                                                                                                                        })}> + </button>
                                                                                                                    </div>
                                                                                                                </div>


                                                                                                            </div>

                                                                                                        )
                                                                                                    }}
                                                                                                </FieldArray>



                                                                                            </div>
                                                                                            {index > 0 && (
                                                                                                <div className="col-sm-4">
                                                                                                    <span style={{ "marginLeft": "290%", "cursor": "pointer" }} onClick={() => remove(index)}><AiIcons.AiOutlineDelete style={{ widh: "30px", fill: "red" }} /></span>
                                                                                                </div>
                                                                                            )}
                                                                                            <hr />
                                                                                        </div>

                                                                                    ))}
                                                                                    <div className="row mt-3">
                                                                                        <div className="col-lg-11"></div>
                                                                                        <div className="col-lg-1 mb-3" >
                                                                                            <button type='button' className="btn btn-primary" onClick={() => push({
                                                                                                nameofprocess: "",
                                                                                                nameofprocessid: "",
                                                                                                processowner: "",
                                                                                                details: "",
                                                                                                reference: "",
                                                                                                comments: "",
                                                                                                clauseWiseObservation: [{ clauseNo: "", Observation: "" }]

                                                                                            })}>Add</button>
                                                                                        </div>
                                                                                    </div>


                                                                                </div>

                                                                            )
                                                                        }}
                                                                    </FieldArray>
                                                                    <hr />
                                                                </div>
                                                                <div className="hrstyle">
                                                                    <h5>A. Summary</h5>
                                                                </div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='textarea' type="text" name='obervations' label='Observations' />
                                                                </div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='textarea' type="text" name='opportunitiesforimprovment' label='Opportunities for Improvement'  />
                                                                </div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='textarea' type="text" name='positivefindingsSurveillance' label='Positive Findings'/>
                                                                </div>

                                                                {/* <--start--> */}
                                                                
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='textarea' type="text" name='ncstatementifany' label='NC Statement(if any)'/>
                                                                </div>
                                                                <div className="hrstyle">
                                                                    <h5>B. Recommendation</h5>
                                                                </div>
                                                                <div className="form2RowDiv">
                                                                    <FormikControl control='select' label='Select Recommendation'  options={recommendationType} name='recommendationType' />
                                                                    <FormikControl control='date' dateFormat="dd-MM-yyyy" name='reportsubdate' className="form-control" label='Report submission Date' />

                                                                </div>
                                                                <div className="hrstyle">
                                                                    <h5>IQCPL Report Submission</h5>
                                                                </div>
                                                                <div className="form2RowDiv">
                                                                    <FormikControl control='input' type="text" name='nameofauditor' label='Name of Auditor'/>
                                                                </div>
                                                                <div className="hrstyle">
                                                                    <h5>Client Acceptance for Report </h5>
                                                                </div>
                                                                <div className="form2RowDiv">
                                                                    <FormikControl control='input' type="text" name='clientname' label='Name'/>
                                                                    <FormikControl control='input' type="text" name='clientdesignation' label='Designation'/>

                                                                </div>
                                                                <div className="hrstyle headingcolor">
                                                                    <h5>C. Surveillance Audit Review-Technical Team(For office use only)</h5>
                                                                </div>
                                                                <div className='mt-3' style={{marginLeft:"1%"}}><h6>Technical Review</h6></div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='textarea' type="text" name='survellianceOneremark' label='Changes (if any) in  Scope Statement against NACE code' placeholder="Comment/Remark"/>
                                                                </div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='textarea' type="text" name='survellianceTworemark' label='Exclusion and Justification adequate' placeholder="Comment/Remark"/>
                                                                </div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='textarea' type="text" name='survellianceThreeremark' label='Has Auditor covered all the applicable Clauses (Surveillance Audit)' placeholder="Comment/Remark"/>
                                                                </div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='textarea' type="text" name='survellianceFourremark' label='Evidences are appropriate' placeholder="Comment/Remark"/>
                                                                </div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='textarea' type="text" name='survellianceFiveremark' label='NC statement and its clause ref' placeholder="Comment/Remark"/>
                                                                </div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='textarea' type="text" name='survellianceSixremark' label='Verification of Corrective actions and Evidence' placeholder="Comment/Remark"/>
                                                                </div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='textarea' type="text" name='survellianceSevenremark' label='Client Acceptance of Surveillance Audit Report' placeholder="Comment/Remark"/>
                                                                </div>
                                                                   
                                                                {/* <div class="row">
                                                                            <div class="card-body table-responsive">
                                                                                <table className="table table-bordered">
                                                                                    <thead className="table-primary">
                                                                                        <tr>
                                                                                            <th className="text-center">#</th>
                                                                                            <th scope="col" className="text-center" width="50%">Technical Review </th>
                                                                                            <th scope="col" className="text-center">Remarks/Comments</th>
                                                                                        </tr>
                                                                                    </thead>
                                                                                    <tbody>
                                                                                        <tr>
                                                                                            <td className="text-center">1</td>
                                                                                            <td>Changes (if any) in  Scope Statement against NACE code</td>
                                                                                            <td ><FormikControl control='inputtable' type="text" name='survellianceOneremark' className="form-control" /> </td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td className="text-center">2</td>
                                                                                            <td>Exclusion and Justification adequate</td>
                                                                                            <td ><FormikControl control='inputtable' type="text" name='survellianceTworemark' className="form-control" /> </td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td className="text-center">3</td>
                                                                                            <td>Has Auditor covered all the applicable Clauses (Surveillance Audit)</td>
                                                                                            <td ><FormikControl control='inputtable' type="text" name='survellianceThreeremark' className="form-control" /> </td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td className="text-center">4</td>
                                                                                            <td>Evidences are appropriate</td>
                                                                                            <td ><FormikControl control='inputtable' type="text" name='survellianceFourremark' className="form-control" /> </td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td className="text-center">5</td>
                                                                                            <td>NC statement and its clause ref</td>
                                                                                            <td ><FormikControl control='inputtable' type="text" name='survellianceFiveremark' className="form-control" /> </td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td className="text-center">6</td>
                                                                                            <td>Verification of Corrective actions and Evidence</td>
                                                                                            <td ><FormikControl control='inputtable' type="text" name='survellianceSixremark' className="form-control" /> </td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td className="text-center">7</td>
                                                                                            <td>Client Acceptance of Surveillance Audit Report</td>
                                                                                            <td ><FormikControl control='inputtable' type="text" name='survellianceSevenremark' className="form-control" /> </td>
                                                                                        </tr>
                                                                                    </tbody>
                                                                                </table>
                                                                            </div> 
                                                                        </div>  */}
                                                                            <div className="form1RowDiv mt-2">
                                                                                <FormikControl control='textarea' type="text" name='auditorcommentnoncon' label='Auditors Comments In case of major Non-Conformities/withdraw/Repeat audit'/>
                                                                            </div>
                                                                            <div className="form1RowDiv">
                                                                                <FormikControl control='textarea' type="text" name='techreviewercomment' label='Technical Reviewer Comment/Remark'/>
                                                                            </div>
                                                                            <div className="form1RowDiv">
                                                                                <FormikControl control='textarea' type="text" name='cdcreviewremark' label='CDC Review Comments (Comments on Continuation/Withdraw/Repeat Audit)'/>
                                                                            </div>

                                                            </div>
                                                        </form>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                            <div className="card-footer">
                                <div className="row">
                                    <div className="col-sm-10"></div>
                                    <div className="col-sm-2">
                                        <button type="submit" className="btn btn-primary" disabled={!formik.isValid}>Submit</button>


                                    </div>

                                </div>
                            </div>
                        </div>
                    </Form>
                }
            </Formik>
        </div>
    )
}

export default Observation